// libraries.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiDocumentsPortal } from '@store/apiSlices/apiSlices';

// interfaces.
import {
  DocumentsByNidParams,
  DocumentsByNidResponse,
} from '@domains/documents-review/interfaces/interfaces';

export const documentsByNid = apiDocumentsPortal.injectEndpoints({
  endpoints: builder => ({
    getDocumentsByNid: builder.query({
      query: ({ country, nid }: DocumentsByNidParams) => {
        return `/documents_by_nid?country=${country}&nid=${nid}`;
      },
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'getDocumentsByNid',
        };
        return modelError;
      },
      transformResponse: (response: DocumentsByNidResponse) => {
        return response.results;
      },
    }),
  }),
});

export const { useGetDocumentsByNidQuery } = documentsByNid;
